export default __webpack_public_path__ + "static/media/surfdemo_2.2b9075c6.mp4";